// extracted by mini-css-extract-plugin
export default {"button":"ip-z","reviewSort":"jp-z"};